module.exports = __webpack_public_path__ + "static/media/MMC-LOGO-1.6e629fb5.png";